import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { STATS, TRUST } from "../data/content";
import { useCountUp } from "../hooks/useCountUp";

const Stat = ({ value, suffix, label }) => {
  const { value: current, ref } = useCountUp(value);
  return (
    <div ref={ref} className="text-center" data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="font-display text-4xl font-bold tracking-tight text-navy dark:text-teal sm:text-6xl">
        {current}
        <span className="text-teal">{suffix}</span>
      </div>
      <div className="mt-2 text-sm font-medium text-muted-foreground">{label}</div>
    </div>
  );
};

const WhyTrust = () => {
  return (
    <section className="relative py-24 sm:py-32 lg:py-40" data-testid="trust-section">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-8 lg:px-12">
        {/* Stats */}
        <Reveal>
          <div className="grid grid-cols-2 gap-8 rounded-3xl border border-border bg-card p-10 shadow-[0_8px_40px_rgb(0,0,0,0.05)] sm:p-14 lg:grid-cols-4">
            {STATS.map((s) => (
              <Stat key={s.label} {...s} />
            ))}
          </div>
        </Reveal>

        {/* Why trust us */}
        <div className="mt-24 grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <Eyebrow>Why Trust Us</Eyebrow>
            <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              Enterprise credibility, proven over 25 years.
            </h2>
            <p className="mt-5 text-muted-foreground">
              A track record spanning Microsoft Dynamics 365, enterprise architecture and AI-powered
              product delivery for the UK and Nigeria.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {TRUST.map((t, i) => (
                <div
                  key={t}
                  className="flex items-start gap-3 rounded-2xl border border-border bg-card p-5 transition-colors hover:border-teal"
                  data-testid={`trust-item-${i}`}
                >
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-teal" />
                  <span className="text-sm font-medium text-foreground">{t}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default WhyTrust;
